<template>
  <div class="border relative px-3 pt-2 pb-4 border-grey-0 mb-4 rounded-tl-xl rounded-br-xl">

    <div class="flex items-center justify-between">
      <div class="  text-lg">
        <span class="font-medium">ID:</span>
      </div>
      <span class="text-secondary-0 text-lg font-bold">
        {{ order.pluOrderId }}
      </span>
    </div>

    <div class="flex items-center justify-between">
      <div class="  text-lg">
        <span class="font-medium">Dátum</span>
      </div>
      <span class="text-secondary-0 text-lg font-bold">
        {{ parseIsoDate(order.createdAt) }}
      </span>
    </div>

    <div class="flex items-center justify-between">
      <div class="  text-lg">
        <span class="font-medium">Stav:</span>
      </div>
      <span class="text-secondary-0 text-lg font-bold">
            <template v-if="order.status === ORDER_STATUS.WAITING_FOR_PAYMENT">
              Čaká na dokončenie platby
            </template>
            <template v-if="order.status === ORDER_STATUS.NEW">
              Čaká na prijate
            </template>
            <template v-else-if="order.status === ORDER_STATUS.CONFIRMED">
              <span class="text-info-0">Čaká na doručenie</span>
            </template>
            <template v-else-if="order.status === ORDER_STATUS.CANCELED">
              <span class="text-danger-0">Zrušená</span>
            </template>
            <template v-else-if="order.status === ORDER_STATUS.DONE">
              <span class="text-success-0">Vybavená</span>
            </template>
            <template v-else>
              -
            </template>
          </span>
    </div>

    <div class="flex items-center justify-between">
      <div class="  text-lg">
        <span class="font-medium">Zaplatená</span>
      </div>
      <span class="text-secondary-0 text-lg font-bold">
           {{ isPayed }}
      </span>
    </div>

    <div class="flex items-center justify-between">
      <div class="  text-lg">
        <span class="font-medium">Cena</span>
      </div>
      <span class="text-secondary-0 text-lg font-bold">
            {{ order.finalPrice }} €
      </span>
    </div>

    <div class="flex items-center justify-between">
      <div class="  text-lg">
        <span class="font-medium">Doprava</span>
      </div>
      <span class="text-secondary-0 text-lg font-bold">
           <template v-if="order.deliveryType === 'personal'">
            Osobne: {{ order.deliveryAddress === 'BO' ? 'Bošany' : 'Partizánske' }}
           </template>
            <template v-else>
              {{ order.deliveryAddress }}
            </template>
          </span>
    </div>

    <div class="flex items-center justify-between">
      <div class="  text-lg">
        <span class="font-medium">Poznámka</span>
      </div>
      <span class="text-secondary-0 max-w-[200px] text-right text-base ">
           {{order.note}}
      </span>
    </div>

    <div class="flex items-center justify-between">
      <div v-if="loading">
        Načitávam kontakt...
      </div>
      <template v-else>
        <span class="text-lg  font-medium">Kontakt: <b>{{ userData.user_metadata.nameAndUsername }}</b></span>
        <div class="flex flex-col">
          <Button @click="callUser" type="button" class="mt-2" label="Volať" size="small" severity="primary"/>
          <span class="text-secondary-0 mt-2 text-lg font-bold">+{{ userData.phone }}</span>
          <Button @click="googleMapToUser" v-if="order.deliveryType !== 'personal'" type="button" class="mt-2"
                  label="Navigovať" size="small"
                  severity="primary"/>
        </div>
      </template>
    </div>

    <hr class="my-1 opacity-25 border-white">

    <template v-for="(item,i) in visibleOrderItems" :key="i">

      <div class=" flex justify-between">
        <div class="space-x-3 flex items-center">
          <span class="text-lg opacity-95">{{ item.title }}</span>
          <span class=" text-lg text-secondary-0 opacity-75"><span class="font-bold">{{
              item.quantity
            }}</span> ks</span>
        </div>
        <span class=" font-light">{{ item.price * item.quantity }} €</span>
      </div>

      <div class="pl-4">
        <div v-for="(extraItem,_) in (item.extra ?? [])" :key="`extra-${i}-${_}`" class=" flex justify-between">
          <div class="space-x-3 flex items-center">
            <span class="text-lg opacity-95">{{ extraItem.title }}</span>
            <span class=" text-lg text-secondary-0 opacity-75"><span class="font-bold">{{
                extraItem.quantity
              }}</span> ks</span>
          </div>
          <span class=" font-light">{{ extraItem.price * extraItem.quantity }} €</span>
        </div>
      </div>

      <hr v-if="i < visibleOrderItems.length - 1" class="my-1 opacity-25 border-white">

    </template>

  </div>
</template>

<script setup>
import {ORDER_STATUS, ORDER_STATUS_OPTIONS, RESTAURANT_PLACES} from "@/content/lists.js";
import {format, parseISO} from "date-fns";
import {computed, ref} from "vue";
import Supabase from "@/utils/Supabase";
import {filterVisibleOrderItems} from "@/utils/orderItems.js";

const props = defineProps({
  order: Object
})

const parseIsoDate = date => {
  const parsedDate = parseISO(date);
  return format(parsedDate, 'dd.MM.yyyy HH:mm');
}

const visibleOrderItems = computed(() =>
  filterVisibleOrderItems(props.order?.orderItems)
)

const isPayed = computed(() => {

  if (props.order.payed) return 'Áno'
  // if (props.order.status === ORDER_STATUS.DONE || props.order.payed) return 'Áno'
  return 'Nie'

})

const userData = ref(null)
const loading = ref(true)
const loadUser = async () => {
  loading.value = true
  const {data: {user}, error} = await Supabase.auth.admin.getUserById(props.order.userId)
  loading.value = false
  if (error) {
    console.error(error)
    return
  }
  userData.value = user
}

loadUser()

const callUser = () => {
  if (!userData.value.phone) return
  window.open(`tel:+${userData.value.phone}`)
}

const googleMapToUser = () => {
  if (!userData.value.address) return
  const url = `https://www.google.com/maps/search/?api=1&query=${props.order.deliveryAddress}`
  window.open(url)
}


</script>
